import React, { useContext, useEffect, useMemo, useState } from 'react'; import { useLocation, useHistory } from 'react-router-dom';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import qs from 'qs';
import Table from './components/Table'
import { pagesList, pagesToggle } from '../../../../services/endpoints/pages';
import NavRoutes from '../../../../components/Navs/NavRoutes';
import { AppearanceContext } from '../../index';
import { getErrorMessage } from '../../../../utils/helper';
import AlertComponent from '../../../../components/Alert';
import PageNotFound from '../../../404';
import { routesAppearance } from '../../helpers';
import Loader from '../../../../components/Loaders/Loader';

const Pages = () => {
  const location = useLocation();
  const history = useHistory();

  const { config, menu } = useContext(AppearanceContext);

  const queryString = qs.parse(location.search.slice(1));
  const routeCreatePage = useMemo(() => routesAppearance.find((route) => route.code === 'create-page'), [])

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState({ page: true, table: false });

  const { pages } = data;

  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, table: true }));
    try {
      const response = await pagesList(queryString);
      if (response.success) {
        setData(response.data);
      }
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, table: false }));
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      if (config?.access?.pages_list) {
        await fetchList(queryString);
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onCreatePage = () => {
    history.push(routeCreatePage.link)
  }

  const onChangeVisibility = async (pageId, visibility) => {
    setData((prevState) => ({
      ...prevState,
      pages: prevState.pages.map((page) => ({
        ...page,
        visibility: page.id === pageId ? visibility : page.visibility,
      })),
    }))

    try {
      await pagesToggle(pageId, visibility)
    } catch (error) {
      setData((prevState) => ({
        ...prevState,
        pages: prevState.pages.map((page) => ({
          ...page,
          visibility: page.id === pageId ? visibility ? 0 : 1 : page.visibility,
        })),
      }))
    }
  }

  useEffect(() => {
    getAllData()
    document.title = 'Pages';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading.page && !init) {
    return <Loader />;
  }

  if (!config?.access?.pages_list) {
    return <PageNotFound />
  }

  return (
    <Grid>
      <Row>
        <Col md={2} mdOffset={1}>
          <NavRoutes
            routes={menu}
          />
        </Col>
        <Col md={8}>
          <div className="loader-container" style={{ minHeight: '600px' }}>
            {error
              ? <AlertComponent text={error} />
              : (
                <div>
                  {config?.access?.pages_create ? <Button onClick={onCreatePage} className="m-b">Add page</Button> : null }
                  {config?.access?.pages_list
                    ? (
                      <div className="m-b">
                        <Table
                          items={pages}
                          config={config}
                          onChangeVisibility={onChangeVisibility}
                        />
                      </div>
                    ) : null }
                </div>
              )}
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default Pages;
